export default "__VITE_ASSET__CiFAXnHg__"